"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _prefixUrl = require("@mapbox/batfish/modules/prefix-url");

var _routeTo = require("@mapbox/batfish/modules/route-to");

var _example = _interopRequireDefault(require("../../components/example"));

var _match = _interopRequireDefault(require("./match.html"));

var _pageShell = _interopRequireDefault(require("/home/toannc/ekmap-platform-map-javascript/docs/components/page-shell.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var frontMatter = {
  title: 'Sắp xếp điểm dữ liệu thành đường đi',
  description: 'Snap to Roads API',
  topics: ['Service'],
  thumbnail: 'direction',
  order: 3,
  contentType: 'example',
  layout: 'page',
  hideFeedback: false,
  language: ['JavaScript'],
  products: ['Mapbox GL JS'],
  headings: []
};

var MarkdownReact = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MarkdownReact, _React$PureComponent);

  var _super = _createSuper(MarkdownReact);

  function MarkdownReact() {
    _classCallCheck(this, MarkdownReact);

    return _super.apply(this, arguments);
  }

  _createClass(MarkdownReact, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_react["default"].createElement(_pageShell["default"], _extends({}, props, {
        frontMatter: frontMatter
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "\u0110\u1EC3 hi\u1EC3u h\u01A1n v\u1EC1 c\xE1c thu\u1ED9c t\xEDnh, tham s\u1ED1 c\u1EE7a ", /*#__PURE__*/_react["default"].createElement("code", null, "ekmapplf.service.SnaptoRoads"), " \u0111\u1ECDc th\xEAm ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "/ekmap-platform-map-javascript/javascript-api/navigation/#match-service-api"
      }, "t\u1EA1i \u0111\xE2y"), "."), /*#__PURE__*/_react["default"].createElement("p", null, "V\xED d\u1EE5 n\xE0y s\u1EED d\u1EE5ng ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://docs.ekgis.vn/ekmap-platform-map-api/navigation/match/"
      }, "eKMap Snap to Roads API"), " d\u1ECBch v\u1EE5 cung c\u1EA5p t\xEDnh n\u0103ng cho ph\xE9p kh\u1EDBp c\xE1c \u0111i\u1EC3m d\u1EEF li\u1EC7u GPS (th\u01B0\u1EDDng kh\xF4ng n\u1EB1m tr\xEAn \u0111\u01B0\u1EDDng giao th\xF4ng do lu\xF4n c\xF3 sai s\u1ED1 v\u1EDBi d\u1EEF li\u1EC7u GPS) v\xE0o m\u1EA1ng l\u01B0\u1EDBi \u0111\u01B0\u1EDDng \u0111\u1EC3 x\xE1c \u0111\u1ECBnh, x\xE2y d\u1EF1ng l\u1EA1i qu\u1EF9 \u0111\u1EA1o di chuy\u1EC3n ho\u1EB7c \u0111\u01B0\u1EDDng \u0111i t\u01B0\u01A1ng \u1EE9ng tr\xEAn b\u1EA3n \u0111\u1ED3."), /*#__PURE__*/_react["default"].createElement(_example["default"], _extends({
        html: _match["default"]
      }, this.props))));
    }
  }]);

  return MarkdownReact;
}(_react["default"].PureComponent);

exports["default"] = MarkdownReact;